import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

const quickLinks = [
  { name: "Shop All", href: "/shop" },
  { name: "Custom Orders", href: "/shop?category=custom" },
  { name: "Cart", href: "/cart" },
  { name: "Policies & Procedures", href: "/policies" },
  { name: "Privacy Policy", href: "/privacy" }
];

const Footer = () => {
  return (
    <footer 
      className="pt-16 pb-8"
      style={{
        background: 'linear-gradient(135deg, #1e3a5f 0%, #152a42 50%, #0f1f30 100%)'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src="https://royal-ink-shop.lovable.app/assets/logo-B4eDz4H_.jpg"
                alt="A&D Royal Ink"
                className="h-12 w-12 rounded-md object-cover"
              />
              <span className="font-serif text-xl font-bold text-white">
                A&D Royal Ink
              </span>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-6">
              Premium custom apparel and accessory printing. We bring your vision to life with quality craftsmanship and royal treatment.
            </p>
            <p className="text-amber-400 font-medium text-sm mb-6">
              Be Your Own Kind of Royal
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="mailto:aj@adroyalink.com"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-amber-400 mb-6 italic">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-amber-400 mb-6 italic">
              Contact
            </h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="mailto:aj@adroyalink.com"
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  aj@adroyalink.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:+14122123091"
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  (412) 212-3091
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <div>
                  <p>213 Smithfield St. 2nd Fl</p>
                  <p>Pittsburgh, PA 15222</p>
                  <p className="text-amber-400 mt-1">By Appointment Only</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-center text-gray-500 text-sm">
            © 2026 A&D Royal Ink. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
